export default __webpack_public_path__ + "static/media/baby_boonet.894edfca.jpg";